import { FC } from 'react';

export const SiloIcon: FC<{ className?: string }> = ({ className }) => (
  <svg className={className} width="24" height="27" viewBox="0 0 24 27" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.7097 10.8V16.2H9.29032V10.8H14.7097ZM14.7097 10.8V0H9.01156C6.95321 0 5.26302 0.331715 3.94099 0.995144C2.60222 1.65857 1.61488 2.59971 0.978972 3.81857C0.326325 5.022 0 6.45686 0 8.12314C0 9.774 0.326325 11.2089 0.978972 12.4277C1.61488 13.6311 2.60222 14.5646 3.94099 15.228C5.26302 15.876 6.95321 16.2 9.01156 16.2H9.29032V27H14.9884C17.0468 27 18.737 26.676 20.059 26.028C21.3978 25.3646 22.3851 24.4311 23.021 23.2277C23.6737 22.0089 24 20.574 24 18.9231C24 17.2569 23.6737 15.822 23.021 14.6186C22.3851 13.3997 21.3978 12.4586 20.059 11.7951C18.737 11.1317 17.0468 10.8 14.9884 10.8H14.7097Z"
      fill="white"
    />
  </svg>
);
